import React from 'react';
import PropTypes from 'prop-types';
import Table from 'components/shared/table';
import GradingStationTableHeader from './GradingStationTableHeader';
import GradingStationTableFooter from './GradingStationTableFooter';
import GradingStationTableBody from './GradingStationTableBody';

const GradingStationTable = props => {
  const {
    itemsToGrade,
    loading,
    page,
    handlePageChange,
    setRowsPerPage,
    rowsPerPage,
    gradableType,
    pageCount,
    query,
  } = props;

  return (
    <Table
      className="GradingStationTable Index-table--multipleHeaders mb-32"
      alternate
      noBorderTop
      roundedBottom
    >
      {gradableType.toLowerCase() === 'lesson' && (
        <GradingStationTableHeader
          columns={[
            '',
            t('grades.grading_station_table.ungraded_submissions_header'),
            t('grades.grading_station_table.longest_days_waiting_header'),
          ]}
        />
      )}
      {gradableType.toLowerCase() === 'available_review_lesson' && (
        <GradingStationTableHeader
          columns={[
            '',
            t('grades.grading_station_table.score_header'),
            t('grades.grading_station_table.available_to_review_header'),
          ]}
        />
      )}

      <GradingStationTableBody
        itemsToGrade={itemsToGrade}
        loading={loading}
        gradableType={gradableType}
        query={query}
        page={page}
      />
      <GradingStationTableFooter
        itemsToGrade={itemsToGrade}
        pageCount={pageCount}
        page={page}
        setPage={handlePageChange}
        rowsPerPage={rowsPerPage}
        setRowsPerPage={setRowsPerPage}
      />
    </Table>
  );
};

GradingStationTable.propTypes = {
  loading: PropTypes.bool,
  handlePageChange: PropTypes.func,
  gradableType: PropTypes.string,
  page: PropTypes.number,
  setRowsPerPage: PropTypes.func,
  rowsPerPage: PropTypes.number,
  itemsToGrade: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.number,
      name: PropTypes.string,
      title: PropTypes.string,
      email: PropTypes.string,
      longestDaysWaiting: PropTypes.number,
      ungradedSubmissions: PropTypes.number,
    }),
  ),
};

export default GradingStationTable;
